<template>
  <v-dialog
    :value="canMerchant && ((getShop && !getTimezone) || forceOpen)"
    width="400"
    color="white black--text"
    persistent
  >
    <v-card>
      <v-card-title class="orange lighten-3">
        <h2 class="text-h4 mt-3 mb-1 black--text">
          Please Confirm your Shop's Timezone
        </h2>
      </v-card-title>
      <v-card-text class="pt-6 pb-8">
        <transition name="fade" mode="out-in">
          <div v-if="success" key="success">
            <h3 class="text-h6">
              <v-icon class="success--text" left>mdi-check-circle</v-icon>
              Thanks for confirming your timezone. You can change it at any time
              in your Shop Settings page.
            </h3>
          </div>
          <div v-else key="prompt">
            <h3 class="text-h6">
              A valid timezone is required to use new and upcoming time-related
              features (daily sales, availability cutoff times, lead times,
              etc.). Please select one to continue.
            </h3>
            <v-autocomplete
              v-model="timezone"
              label="Timezone"
              outlined
              :items="timezones"
              item-text="name"
              item-value="value"
              :loading="loading"
              clearable
            />
          </div>
        </transition>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <BtnBaseBlue
          @click="setTimezone"
          :disabled="!timezone"
          :loading="loading"
          >Save Timezone</BtnBaseBlue
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BtnBaseBlue from '@/components/BtnBaseBlue'
export default {
  name: 'DialogUpdateTimezone',
  components: {
    BtnBaseBlue,
  },
  data() {
    return {
      loading: false,
      timezone: null,
      success: false,
      forceOpen: false,
      timezones: [
        { name: 'Pacific (PDT)', value: 'America/Los_Angeles' },
        { name: 'Mountain (MDT)', value: 'America/Denver' },
        { name: 'Central (CDT)', value: 'America/Chicago' },
        { name: 'Eastern (EDT)', value: 'America/New_York' },
        { name: 'Alaska (ADT)', value: 'America/Anchorage' },
        { name: 'Hawaii (HST)', value: 'Pacific/Honolulu' },
      ],
    }
  },
  computed: {
    ...mapGetters('shop', ['getTimezone', 'getShop']),
    ...mapGetters('auth', ['canMerchant']),
  },
  mounted() {
    if (!this.getTimezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  methods: {
    ...mapActions('shop', ['updateSetting']),
    async setTimezone() {
      this.success = false
      this.forceOpen = true
      try {
        this.loading = true
        await this.updateSetting({
          name: 'timezone',
          val: this.timezone,
        })
        this.success = true
        await new Promise((resolve) => setTimeout(resolve, 2500))
        this.forceOpen = false
      } catch (e) {
        Promise.reject(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
